import PaymentType from './paymentType.js'
import TransBankPaymentType from './transBankPaymentType.js'

class TransBankPaymentAdapter {
    constructor() {

    }

    adaptTransBankPayment(paymentType) {
        let adaptedPayment = "";
        switch (paymentType) {
            case PaymentType.VISA:
                adaptedPayment = TransBankPaymentType.VISA;
                break;
            case PaymentType.MC:
                adaptedPayment = TransBankPaymentType.MASTERCARD;
                break;
            case PaymentType.DISC:
                adaptedPayment = TransBankPaymentType.DISCOVER;
                break;
            case PaymentType.AMEX:
                adaptedPayment = TransBankPaymentType.AMERICAN_EXPRESS;
                break;
            case PaymentType.DINC:
                adaptedPayment = TransBankPaymentType.DINERS;
                break;
            case PaymentType.ARGE:
                adaptedPayment = TransBankPaymentType.ARGENCARD;
                break;
            case PaymentType.LCAB:
                adaptedPayment = TransBankPaymentType.CABAL;
                break;
            case PaymentType.TARJ:
                adaptedPayment = TransBankPaymentType.NARANJA;
                break;
            case PaymentType.JCB:
                adaptedPayment= TransBankPaymentType.JCB;
                break;
            default:
                adaptedPayment = "";
                break;
        }

        return adaptedPayment;
    }
}

//Export singleton es6 class
export default new TransBankPaymentAdapter();